import { Link } from 'react-router-dom'
import { FC, ComponentProps } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import { twMerge } from '@lib/tailwind-merge'

export const PopoutLink: FC<ComponentProps<typeof Link>> = (props) => (
  <Link
    className={twMerge(
      'inline-flex gap-1 items-center text-hyperlink-blue',
      props.className,
    )}
    target="_blank"
    {...props}
  >
    {props.children} <FontAwesomeIcon icon={faSquareArrowUpRight} />
  </Link>
)
